import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

import borderLinSrc from "../../../image/assets/alert-border-line.svg";
import { closeAlert } from "../../../redux/actions/alert/alertActions";

import { StyledAlert } from "./styledAlert";

const AlertComponent = ({ variant, children, handleClose, className }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const alertState = useSelector((state) => state.alert);
  if (!alertState.isModal && alertState.isShow) {
    setTimeout(() => {
      dispatch(closeAlert());
    }, alertState.showTime);
  }

  useEffect(() => {
    dispatch(closeAlert());
  }, [location]);

  return (
    <StyledAlert
      show={alertState.isShow}
      $isModal={alertState.isModal}
      variant={variant}
      onClose={handleClose}
      className={`d-flex justify-content-center align-items-center ${className}`}
      $alertBackground={alertState.background}
    >
      {!alertState.isModal ? (
        <>
          <img src={borderLinSrc} alt="پیام" className="top-line" />
          {alertState.content || children}
          <img src={borderLinSrc} alt="پیام" className="bottom-line" />
        </>
      ) : (
        alertState.content || children
      )}
    </StyledAlert>
  );
};

export default React.memo(AlertComponent);
